import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import CaseSearch from "../components/core/case_search";
import moment from "moment";
import CustomSearchSortHeader from "../components/core/CustomSearchSortHeader";
import Pagenated from "../components/pagenated";
import JisEmptyList from "../components/controls/emptylist";

function ESwearing() {
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);

  const [docs, setDocs] = useState([]);
  const [cases, setCases] = useState([]);
  const [refs, setRefs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [casetype, setCaseType] = useState("litigation");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [count, setCount] = useState(0);

  const navigate = useNavigate();
  // loads on first render and whenever the page or page size changes
  useEffect(() => {
    if (isSearch && search) {
      runSearch(search, pageIndex, pageSize);
    } else {
      onLoad();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, pageSize]);

  const onPagePick = (pick) => {
    setPageIndex(pick.id - 1);
  };

  const onPageSizeChange = (k) => {
    setPageIndex(0);
    setPageSize(Number(k));
  };

  const onLoad = async (searchOverride) => {
    //for account registration

    var url = `${Constants.apiUrl}/filing/my-eswearing-cases/pending/${pageIndex}/${pageSize}`;

    try {
      setLoading(true);
      // Send default structure for initial load/pagination when not searching
      const payload = (searchOverride === undefined ? search : searchOverride) || {
        caseTitle: "",
        caseNumber: "",
        fromDate: "",
        toDate: "",
        filingtype: "all",
        caseprocess: "all",
        caseTypeId: "",
        caseCategoryId: ""
      };
      const resp = await fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      if (data.code == 0) {
      }
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setCases(data.items);
        if (pageIndex == 0) setCount(data.totalCount || 0); // the server only counts on the first page
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        alert(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const ReworkStr=(item)=>{
    if(item==null)
      return '';

      if(item.isRework==true){
        return 'Rework Required'
      }
      else if(item.isRework==false){
        return 'Rework Completed'
      }else{
        return 'N/A';
      }


     /*  if(item.isRework==true && item.reworkedOn==null){
        return 'Rework Required'
      }
      else if(item.isRework==true && item.reworkedOn!=null){
        return 'Rework Completed'
      }else{
        return 'N/A';
      } */
  }

  const onView = (item) => {
    navigate(`/prepare-document/${item.docupload[0].id}/legal`);
  };

  // a new search from the header always starts from page 1
  const onSearch = (sear) => {
    // Check if search object has any meaningful values
    const hasSearchData = sear && Object.keys(sear).length > 0 &&
      Object.values(sear).some(value => value !== null && value !== undefined && value !== "");

    if (!hasSearchData) {
      // If search is empty, reset to normal load mode
      setSearch(null);
      setIsSearch(false);
      if (pageIndex !== 0) setPageIndex(0); // the effect reloads page 1
      else onLoad(null);
      return;
    }

    setSearch(sear);
    setIsSearch(true);
    if (pageIndex !== 0) setPageIndex(0); // the effect runs the search for page 1
    else runSearch(sear, 0, pageSize);
  };

  const runSearch = async (sear, pIndex, pSize) => {
    setErr("");
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/my-eswearing-cases/pending/${pIndex}/${pSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pIndex == 0) setCount(data.totalCount || 0);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  return (
    <div>
      <div>
        {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
        <CustomSearchSortHeader
          onSearch={onSearch}
          frequentData={frequentData}
          isSearchOnly
        />

        <div className="table">
          <div class="section-cases">
            <span>
              E-Swearing Cases 
            </span>
          </div>
          <div className="table-wrapper">
            <table className="case-table">
              <thead>
                <tr>
                  {/* <th className="col-id">ID</th> */}

                  <th className="col-title">Suit Number</th>
                  <th className="col-title"> Title</th>
                  <th>Document Count</th>
                  <th>Status</th>
                  <th className="col-medium">Schedule Date and Time</th>
                  <th className="col-title">Zoom Link</th>
                {  <th className="col-action">Rework</th>}
                  <th className="col-action">Actions</th>
                </tr>
              </thead>
              <tbody>
                {cases?.map((item, id) => {
                  return (
                    <tr key={id}>
                      {/*  <td>{item.id}</td> */}
                      <td>
                        {item.case.caseNumber ?? item.case.referenceNumber}
                      </td>
                      <td>{item.case.caseTitle || "N/A"}</td>
                      <td>{item?.docupload[0]?.documentcount || "N/A"}</td>
                      <td>
                        {item.isCompleted
                          ? "Process Completed"
                          : "Pending Upload/Oath"}
                      </td>
                      <td
                        className={
                          item.docupload[0]?.schedule != null
                            ? "date-time"
                            : "date-time pends"
                        }
                      >
                        {item.docupload[0]?.schedule != null
                          ? moment(item.docupload[0]?.schedule).format(
                              "dddd, MMMM Do YYYY h:mm a",
                            )
                          : "No scheduled date"}
                      </td>
                      <td
                        className={
                          item.docupload[0]?.schedule != null
                            ? "zoom"
                            : "zoom pends"
                        }
                      >
                        {(item.docupload[0]?.zoomLink != null && (
                          <a href={item.docupload[0]?.zoomLink} target="_blank">
                            {" "}
                            Zoom Link{" "}
                          </a>
                        )) ||
                          "N/A"}
                      </td>
                      <td>{ReworkStr(item.docupload[0])} </td>
                      <td>
                        {" "}
                        <JisButton
                          variant="plain"
                          className="black"
                          onClick={() => onView(item)}
                        >
                          View Documents Attached
                        </JisButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {!loading && cases?.length === 0 && (
              <JisEmptyList title="No e-swearing cases found" />
            )}
          </div>
          {err && <div className="error-message">{err}</div>}
          {count > 0 && (
            <Pagenated
              onChangePageSize={onPageSizeChange}
              size={pageSize}
              total={count}
              maxPage={20}
              onPick={onPagePick}
            />
          )}
        </div>
      </div>
      <BackLoader open={loading} />
    </div>
  );
}

export default ESwearing;
